'use client'

import { Suspense } from 'react'

import dynamic from 'next/dynamic'

import type { TabbedContentClientProps } from './tabbed-content'

const Tabs = dynamic(() => import('./tabbed-content').then((module) => module.TabbedContentClient))

export const TabbedContentLazy = (props: TabbedContentClientProps) => (
  <Suspense
    fallback={
      <div {...props.editableProps} className={props.fullWidth ? 'not-prose w-full' : 'not-prose'} aria-busy="true">
        {props.tabs[0]?.content}
      </div>
    }
  >
    <Tabs {...props} />
  </Suspense>
)
